import * as React from 'react';

import { ShellMainRoot, ShellFooterSlot } from './AppShell.styled';
import { useAppShell } from './useAppShell';
import type { MainPadding, ShellVariant } from './AppShell.styled';

/* ─────────────────────────── Types ──────────────────────────────────────── */

export interface AppShellMainProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  backgroundImage?: string;
  padding?: MainPadding;
  footer?: React.ReactNode;
}

/* ─────────────────────────── Component ──────────────────────────────────── */

const AppShellMain = React.forwardRef<HTMLElement, AppShellMainProps>(
  function AppShellMain(props, ref) {
    const { children, backgroundImage, padding, footer, id, ...rest } = props;
    const { variant } = useAppShell();

    const resolvedPadding: MainPadding = padding ?? (variant === 'minimal' ? 'none' : 'standard');
    const resolvedBgImage = variant === 'minimal' ? undefined : backgroundImage;

    return (
      <ShellMainRoot
        ref={ref}
        $bgImage={resolvedBgImage}
        $padding={resolvedPadding}
        $variant={variant as ShellVariant}
        id={id}
        {...rest}
      >
        {children}
        {footer != null && <ShellFooterSlot>{footer}</ShellFooterSlot>}
      </ShellMainRoot>
    );
  },
);

AppShellMain.displayName = 'AppShell.Main';

export { AppShellMain };
